import React, { useEffect, useContext } from 'react';
import { captchaPuzzleContext } from '../../../contexts/contexts';

export const Captcha = () => {
  useEffect(() => {
    renderCaptcha();
  }, []);

  const captchaContext = useContext(captchaPuzzleContext);

  const renderCaptcha = () => {
    return new Promise((resolve, reject) => {
      captchaContext.setCaptchaPuzzle({
        showModal: true,
        newRequestConfig: '',
        resolve: resolve,
        reject: reject,
      });
    });
  };

  return (
    <div className="card bg-white" data-testid="captcha-container">
      {/* Serves as a blank background for aws-waf-captcha to render in front of */}
    </div>
  );
};
